import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import { ProjectNew } from '../../components/Project';
import BasicLayout from '../BasicLayout';
import addHistoryRecord from '../../redux/actions/history';
import { selectProject } from '../../redux/actions/projects';
import { OPERATION_TYPES } from '../../constants';

import { uploadFile } from '../../helpers/fileHelpers';

class ProjectNewContainer extends Component {
  constructor(props) {
    super(props);
    this.createProject = this.createProject.bind(this);
  }

  createProject(data) {
    const { currentOrganizationId } = this.props;

    this.props.firebase
      .pushWithMeta('projects', {
        name: data.name,
        description: data.description,
        isPrivate: data.private || false,
        members: {
          [this.props.auth.uid]: true,
        },
        owners: {
          [this.props.auth.uid]: true,
        },
        organizations: {
          [currentOrganizationId]: true,
        },
      })
      .then((snap) => {
        if (data.favicon && data.favicon.length > 0) {
          uploadFile(
            this.props.firebase,
            `files/${snap.key}/favicon`,
            `/projects/${snap.key}/favicon`,
            data.favicon[0],
          );
        }

        if (data.branding_logo && data.branding_logo.length > 0) {
          uploadFile(
            this.props.firebase,
            `files/${snap.key}/branding_logo`,
            `/projects/${snap.key}/branding_logo`,
            data.branding_logo[0],
          );
        }

        this.props.addHistoryRecord(snap.key, 'projects', OPERATION_TYPES.CREATE);
        this.props.selectProject(snap.key);
      });
  }

  render() {
    const { match } = this.props;
    return (
      <BasicLayout
        match={match}
        searchEnabled={false}
        toolbar={
          <div
            style={{
              display: 'flex',
              flex: 1,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <div style={{ flex: 1, textAlign: 'center' }}>{'Create new project'}</div>
          </div>
        }
      >
        <div style={{ display: 'flex', flex: 1, flexDirection: 'row', backgroundColor: '#F2F2F2' }}>
          <ProjectNew {...this.props} onSubmit={this.createProject} />
        </div>
      </BasicLayout>
    );
  }
}

ProjectNewContainer.propTypes = {
  match: PropTypes.shape({
    isExact: PropTypes.bool.isRequired,
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  auth: PropTypes.shape({
    uid: PropTypes.string.isRequired,
  }).isRequired,
  firebase: PropTypes.shape({
    auth: PropTypes.func.isRequired,
    pushWithMeta: PropTypes.func.isRequired,
    updateWithMeta: PropTypes.func.isRequired,
    uploadFile: PropTypes.func.isRequired,
  }).isRequired,
  addHistoryRecord: PropTypes.func.isRequired,
  selectProject: PropTypes.func.isRequired,
  currentOrganizationId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const {
    firebase: { auth },
    router,
    organizations,
  } = state;
  return {
    auth,
    location: router.location,
    currentOrganizationId: organizations.currentOrganizationId,
  };
};

const mapDispatchToProps = dispatch => ({
  showNotification: (notification) => {
    dispatch(notification);
  },
  addHistoryRecord: (id, recordType, operation) => {
    dispatch(addHistoryRecord(id, recordType, operation));
  },
  selectProject: (projectId) => {
    dispatch(selectProject(projectId));
  },
});

export default compose(
  connect(({ firebase }) => ({
    auth: firebase.auth,
  })),
  firebaseConnect(),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ProjectNewContainer);



// WEBPACK FOOTER //
// ./src/containers/Project/ProjectNewContainer.js